import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import LeadManagement from './LeadManagement';
import ChatSystem from './ChatSystem';
import FollowUpDashboard from './FollowUpDashboard';
import NotificationBell from './NotificationBell';

const DashboardLead = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('leads');
  const [showChat, setShowChat] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [followUps, setFollowUps] = useState([]);
  const [leadManagementTab, setLeadManagementTab] = useState('dashboard'); // For LeadManagement internal tabs

  const handleChatToggle = () => {
    setShowChat(prev => !prev);
  };

  const handleMarkAsRead = (notificationId) => {
    setNotifications(prev => prev.filter(n => n.id !== notificationId));
  };

  const handleMarkAllAsRead = () => {
    setNotifications([]);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      {/* Header with Notification Bell */}
      {/* <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-gray-900">CRM Dashboard</h1>
            </div>
            <div className="flex items-center space-x-4">
              <NotificationBell 
                notifications={notifications}
                followUps={followUps}
                onMarkAsRead={handleMarkAsRead}
                onMarkAllAsRead={handleMarkAllAsRead}
              />
              <div className="flex items-center space-x-2">
                <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                  <span className="text-white text-sm font-medium">
                    {user?.name?.charAt(0) || 'U'}
                  </span>
                </div>
                <span className="text-sm font-medium text-gray-700">{user?.name || 'User'}</span>
              </div>
            </div>
          </div>
        </div>
      </header> */}

      {/* Main Content */}
      <main className="py-4 px-2">
        {/* Tab Navigation */}
        <div className="bg-white/80 backdrop-blur-md shadow-xl rounded-2xl mb-4 border border-gray-200/50">
          <div className="border-b border-gray-200/50">
            <div className="flex justify-between items-center px-4 py-2 flex-wrap gap-2">
              {/* Left: Lead Management Tab */}
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => setActiveTab('leads')}
                  className={`py-2 px-3 font-semibold text-sm transition-all duration-200 rounded ${
                    activeTab === 'leads'
                      ? 'text-blue-600 bg-blue-50'
                      : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  📊 Lead Management
                </button>
              </div>

              {/* Right: Navigation Buttons for LeadManagement */}
              {activeTab === 'leads' && (
                <div className="flex items-center flex-wrap gap-1.5">
                  <button
                    onClick={() => setLeadManagementTab('dashboard')}
                    className={`px-3 py-1.5 rounded-lg font-semibold text-sm transition-all duration-200 ${leadManagementTab === 'dashboard'
                      ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                  >
                    🏠 Home
                  </button>

                  <button
                    onClick={() => setLeadManagementTab('analytics')}
                    className={`px-3 py-1.5 rounded-lg font-semibold text-sm transition-all duration-200 ${leadManagementTab === 'analytics'
                      ? 'bg-gradient-to-r from-green-600 to-emerald-600 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                  >
                    📊 Analytics
                  </button>

                  <button
                    onClick={() => setLeadManagementTab('followups')}
                    className={`px-3 py-1.5 rounded-lg font-semibold text-sm transition-all duration-200 ${leadManagementTab === 'followups'
                      ? 'bg-gradient-to-r from-pink-600 to-rose-600 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                  >
                    📞 Follow-ups
                  </button>

                  <button
                    onClick={() => setLeadManagementTab('settings')}
                    className={`px-3 py-1.5 rounded-lg font-semibold text-sm transition-all duration-200 ${leadManagementTab === 'settings'
                      ? 'bg-gradient-to-r from-purple-600 to-violet-600 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                  >
                    ⚙️ Settings
                  </button>


                </div>
              )}
            </div>
          </div>
        </div>

        {/* Tab Content */}
        <div className="space-y-6">
          {activeTab === 'leads' && (
            <LeadManagement 
              activeTab={leadManagementTab}
              setActiveTab={setLeadManagementTab}
            />
          )}
          {activeTab === 'followups' && (
            <FollowUpDashboard 
              onNotificationsUpdate={setNotifications}
              onFollowUpsUpdate={setFollowUps}
            />
          )}
        </div>
      </main>

      {/* Chat System */}
      <ChatSystem
        currentUser={user}
        isOpen={showChat}
        onToggle={handleChatToggle}
      />
    </div>
  );
};

export default DashboardLead;
